import React from 'react';
import close from '../../images/close.png'

const Modal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;
  return (
    <div className="fixed left-0 top-0 z-50 inset-0 w-full h-full backdrop-blur flex items-center justify-center overflow-y-auto px-4 py-6">
        <div className="relative w-full max-w-[92vw] md:w-[658px] bg-[#FE9ECE] shadow-lg py-8 md:py-10 px-4 md:px-8 rounded-[32px] sm:rounded-[48px] md:rounded-[60px] filter-drop animate-fade-in-up">
            <button
                onClick={onClose}
                className="absolute top-6 sm:top-8 right-5 md:right-8"
            >
            <img src={close} className='w-[24px] h-[22px] sm:w-[28px] sm:h-[25px]' alt="Close icon" />
            </button>
            <div className="p-2 md:p-4">{children}</div>
        </div>
    </div>
  );
};

export default Modal;
